import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  toggle() {
    const isOpen = this.menuTarget.classList.toggle("open")
    this.buttonTarget.setAttribute("aria-expanded", isOpen)
  }
}
